import React from "react";
import { ModalContainer, ModalContent, Close } from "./styles";
import CloseSVG from "../../../resources/close.svg";

function Modal({ children, onClose }) {
  return (
    <ModalContainer>
      <Close onClick={onClose} src={CloseSVG} />
      <ModalContent> {children}</ModalContent>
    </ModalContainer>
  );
}
export default Modal;
